import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MdEmail, MdArrowBack } from 'react-icons/md';
import { forgotPassword } from '../redux/actions/authActions';
import { AlmataMainLogo } from '../../assets/image';

const ForgotPassword = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const { forgotPasswordLoading, forgotPasswordMessage, forgotPasswordError } = useSelector(state => state.auth);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (forgotPasswordMessage) {
      setSent(true);
    }
  }, [forgotPasswordMessage]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(forgotPassword(email));
  };

  if (sent) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <img 
              src={AlmataMainLogo}
              alt="Cyber Risk Report Logo" 
              className="login-logo"
            />
            <h1 className="login-title">Password Sent</h1>
            <p className="login-subtitle text-primary">{forgotPasswordMessage} in {email}</p>
          </div>
          
          <button 
            onClick={onBackToLogin}
            className="back-to-login-btn"
          >
            <MdArrowBack />
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img 
            src={AlmataMainLogo}
            alt="Cyber Risk Report Logo" 
            className="login-logo"
          />
          <h1 className="login-title">Forgot Password</h1>
          <p className="login-subtitle">Enter your email to get a new password</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <div className="input-wrapper">
              {/* <MdEmail className="input-icon" /> */}
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
          </div>
          
          <button type="submit" className="login-btn" disabled={forgotPasswordLoading}>
            {forgotPasswordLoading ? 'Sending...' : 'Send New Password'}
          </button>
          
          <button 
            type="button"
            onClick={onBackToLogin}
            className="back-to-login-btn"
          >
            <MdArrowBack />
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;